import { NotificationRenderer } from './NotificationRenderer';
import { ConfirmationRenderer } from './ConfirmationRenderer';

export function GlobalOverlays() {
  return (
    <>
      <NotificationRenderer />
      <ConfirmationRenderer />
    </>
  );
}
